import keyMirror from 'keymirror';

export default keyMirror({
    NOTIFY: null,
    NOTIFICATION_NEXT: null,

    SNACK: null,
    SNACK_NEXT: null
});
